function GameRouteLoading({ label = 'Loading…' }) {
  return (
    <div className="game-frame-buffer game-frame-buffer--route">
      <div className="game-frame-buffer__inner">
        <span className="game-frame-buffer__pulse" aria-hidden="true" />
        <p className="game-frame-buffer__label">{label}</p>
      </div>
    </div>
  );
}

export default GameRouteLoading;
